import { WidgetTeacherHomework } from './widget-teacher-homework.model';
import { Section } from '@/courses/models/section.model';
import { User } from '@/core/models/user.model';
import { WidgetTeacherPerson } from './widget-teacher-person.model';
import { WidgetGradingDetails } from './widget-grading-details.model';

export class WidgetTeacherSectionItem {
  expiration:boolean;
  courseId: number;
  classId: number;
  feedback: WidgetTeacherHomework;
  response: WidgetTeacherHomework;
  responseDraft: WidgetTeacherHomework;
  feedbackDraft: WidgetTeacherHomework;
  gradingDetails: [WidgetGradingDetails];
  section: Section;
  student: WidgetTeacherPerson;
  constructor(data: any) {
    this.expiration=data.expiration;
    this.classId = data.classId;
    this.courseId = data.courseId;
    this.responseDraft = data.responseDraft;
    this.student = data.student ? new WidgetTeacherPerson({
      courseId: data.courseId,
      classId: data.classId,
      ...data.student
    }) : data.student;
    this.response = data.response ? new WidgetTeacherHomework({
      ...data.response,
      sectionListId: data.sectionListId
    }) : data.response;
    this.section = data.section ? new Section(data.section) : data.section;
    this.feedback = data.feedback ? new WidgetTeacherHomework(data.feedback) : data.feedback;
    this.feedbackDraft = data.feedbackDraft ? new WidgetTeacherHomework(data.feedbackDraft) : data.feedbackDraft;
    this.gradingDetails = data.gradingDetails;
  }
}